import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

var GridNavigationDirection;
(function(GridNavigationDirection) {
    GridNavigationDirection["UP"] = 'up';
    GridNavigationDirection["DOWN"] = 'down';
    GridNavigationDirection["LEFT"] = 'left';
    GridNavigationDirection["RIGHT"] = 'right';
})(GridNavigationDirection || (GridNavigationDirection = {}));
function useGridNavigation(isActive, grid, targetElement, close) {
    React.useEffect(()=>{
        function handleKeyDownEvent(event) {
            switch(event.key){
                case 'Down':
                case 'ArrowDown':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.DOWN
                    });
                    break;
                case 'Up':
                case 'ArrowUp':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.UP
                    });
                    break;
                case 'Left':
                case 'ArrowLeft':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.LEFT
                    });
                    break;
                case 'Right':
                case 'ArrowRight':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.RIGHT
                    });
                    break;
                case 'Esc':
                case 'Escape':
                    close();
                    break;
            }
        }
        const target = targetElement.current;
        if (isActive && target) {
            target.addEventListener('keydown', handleKeyDownEvent, false);
            return ()=>target.removeEventListener('keydown', handleKeyDownEvent, false)
            ;
        }
    }, [
        isActive,
        targetElement.current
    ]);
    const [state, dispatch] = React.useReducer(navigationReducer, {
        colIndex: 0,
        rowIndex: 0,
        grid
    });
    function setState(rowIndex, colIndex) {
        dispatch({
            type: 'SET',
            payload: {
                rowIndex,
                colIndex
            }
        });
    }
    return [
        {
            colIndex: state.colIndex,
            rowIndex: state.rowIndex
        },
        setState
    ];
}function navigationReducer(state, action) {
    switch(action.type){
        case GridNavigationDirection.UP:
            {
                const rowIndex = state.rowIndex - 1;
                if (rowIndex < 0) {
                    return state;
                }
                return swcHelpers.objectSpread({}, state, {
                    rowIndex
                });
            }
        case GridNavigationDirection.DOWN:
            {
                const rowIndex = state.rowIndex + 1;
                if (rowIndex >= state.grid[state.colIndex]) {
                    return state;
                }
                return swcHelpers.objectSpread({}, state, {
                    rowIndex
                });
            }
        case GridNavigationDirection.LEFT:
            {
                const colIndex = state.colIndex - 1;
                if (colIndex < 0) {
                    return state;
                }
                const newState = swcHelpers.objectSpread({}, state, {
                    colIndex
                });
                if (state.rowIndex >= state.grid[colIndex]) {
                    newState.rowIndex = state.grid[colIndex] - 1;
                }
                return newState;
            }
        case GridNavigationDirection.RIGHT:
            {
                const colIndex = state.colIndex + 1;
                if (colIndex >= state.grid.length) {
                    return state;
                }
                const newState = swcHelpers.objectSpread({}, state, {
                    colIndex
                });
                if (state.rowIndex >= state.grid[colIndex]) {
                    newState.rowIndex = state.grid[colIndex] - 1;
                }
                return newState;
            }
        case 'SET':
            {
                const { colIndex , rowIndex  } = action.payload;
                if (colIndex >= state.grid.length || rowIndex >= state.grid[colIndex]) {
                    return state;
                }
                return swcHelpers.objectSpread({}, state, action.payload);
            }
        default:
            {
                throw new Error();
            }
    }
}

export { GridNavigationDirection, useGridNavigation as default, navigationReducer };
//# sourceMappingURL=useGridNavigation.js.map
